import React from "react"
import styled from "@emotion/styled"

import Tag from "../tag/tag"

const ImageWrapper = styled.div`
  position: relative;
  height: 100%;
`

const ImageBadge = styled.div`
  position: absolute;
`

const Image = styled.img`
  width: 458px;
  height: 100%;
  object-fit: cover;
  object-position: ${(props) => props.direction};
  //border-radius: 8px;
`

const ResultsImage = ({ image, label, alt, imageDirection, badgePosition }) => {
  const badgeOffset = "8px"
  const badgePositions = {
    "top-left": { top: badgeOffset, left: badgeOffset },
    "top-right": { top: badgeOffset, right: badgeOffset },
    "bottom-left": { bottom: badgeOffset, left: badgeOffset },
    "bottom-right": { bottom: badgeOffset, right: badgeOffset },
  }

  return (
    <ImageWrapper>
      <ImageBadge style={badgePositions[badgePosition]}>
        <Tag
          data={{
            line: label,
            classes: "bg-nova-base-solid-20",
          }}
        />
      </ImageBadge>
      <Image
        src={image}
        alt={alt}
        direction={imageDirection}
        loading={"lazy"}
      />
    </ImageWrapper>
  )
}

export default ResultsImage
